import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import firebaseConfig from '../firebase-applet-config.json';

// Firestore database ID для проекта ownode (единая точка правды).
// Переименовать базу в Firebase нельзя, поэтому держим константу здесь
// и в остальном коде используем только `db`.
const FIRESTORE_DB_ID = firebaseConfig.firestoreDatabaseId;

const app = initializeApp(firebaseConfig);

// Offline persistence через IndexedDB.
// Если касса на секунду теряет интернет — заказы не отваливаются,
// а ставятся в очередь и синкаются при возврате связи.
// persistentMultipleTabManager — корректная работа если открыто несколько
// вкладок (касса + админка одновременно).
export const db = initializeFirestore(
  app,
  {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  },
  FIRESTORE_DB_ID
);

export const auth = getAuth(app);
export const storage = getStorage(app);
